import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { PrimeXProductType } from '../../../../../types';
import { isPrimeX } from '../../../../../types';
import { isRecordIntact } from '../../prime-100/utils';
import type { GetPrimeXQuoteDetailsResponse } from '../../../../../api/quotes.api.types';
import { getPrimeXQuoteDetails } from '../../../../../api';

const useGetPrimeXQuoteDetails = (params: UseGetPrimeXQuoteDetailsParams) => {
  return useQuery<GetPrimeXQuoteDetailsResponse, AxiosError>({
    queryKey: ['prime-x-quote-details', { params }],
    queryFn: () =>
      getPrimeXQuoteDetails(params.product!, params.id!, {
        params: { view: 'full' },
      }).then((res) => {
        return res.data.data;
      }),
    enabled: isRecordIntact(params) && isPrimeX(params.product as string),
    ...params.options,
  });
};

export default useGetPrimeXQuoteDetails;

type UseGetPrimeXQuoteDetailsParams = {
  id: string | undefined;
  product: PrimeXProductType | undefined;
  options?: Record<string, unknown>;
};
